// v2 campaign catalog lane — owned by the same agent as app/v2/slot5.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const slot5Catalog: V2CatalogEntry[] = [
  {
    rank: 8,
    title: 'Interface Monitor Console',
    route: '/interfaces/console2',
    faithfulRoute: '/browse/if-ul-transaction-maintenance-search',
    score: 19,
    blurb:
      'One cross-feed health wall with exact 24h Errored/Queued/Processed counts and multi-select requeue, instead of opening fourteen if_* grids one Query-By pane at a time.',
  },
  {
    rank: 9,
    title: 'Item Master',
    route: '/items/master2',
    faithfulRoute: '/items/master/:ownerId/:itemId',
    score: 19,
    blurb:
      'Identity badges plus live onhand/ordered behaviour up front, 17 surfaces folded into 5 questions, and one Save bar that names which sections you changed.',
  },
  {
    rank: 19,
    title: 'Interface Services',
    route: '/interfaces/services2',
    faithfulRoute: '/browse/interface-services',
    score: 18,
    blurb:
      'Every service as a health-board row — state badge, plain-English schedule, past-schedule verdict — with Suspend/Resume/Run Now per row instead of one long mostly-greyed form.',
  },
  {
    rank: 20,
    title: 'Labor Task Board',
    route: '/labor/board2',
    faithfulRoute: '/browse/prod-labor-tasks',
    score: 18,
    blurb:
      'A shift board that lands on this-warehouse/open/today results with the overrun count already computed, and puts Start/Pause/Restart/Stop/Close/Archive plus the roster on the selected row instead of two navigations deep.',
  },
  {
    rank: 41,
    title: 'Billing Transaction Search',
    route: '/billing/transactions2',
    faithfulRoute: '/browse/billing-transactions',
    score: 17,
    blurb:
      'The charge roll-up the Total Charges footer already proves is computable — open vs summarized, by bill code, by owner, exception pins — with "Invoice these" wired to the existing Invoice Batch / Summary Invoice modals.',
  },
  {
    rank: 42,
    title: 'Configuration (System / User)',
    route: '/config/configuration2',
    faithfulRoute: '/browse/configuration',
    score: 17,
    blurb:
      'Leads with the diff — overridden / non-default / locked / owner-level — over the existing tree, with per-row provenance and Revert to default; the user menu leaf keeps its own locked-mode route at /config/configuration-user2.',
  },
  {
    rank: 40,
    title: 'Item Search',
    route: '/items/search2',
    faithfulRoute: '/browse/items-search',
    score: 17,
    blurb:
      'Answers "400 hits — which family?" with a facet strip that narrows client-side, a rail that asks what you know instead of one wide criteria pane, and the highlighted row\'s onhand/available in a peek panel so the search → Item Status → back loop stops.',
  },
  {
    rank: 48,
    title: 'Automation & Servers',
    route: '/admin/automation2',
    faithfulRoute: '/browse/auto-process-timer',
    score: 16,
    blurb:
      'One "what runs on a schedule" board over the timer, process-server and calc-server screens, with the OVERDUE verdict (now beyond last run + interval) nobody can compute today and enable/disable/reset as row actions where the write path really supports them.',
  },
];
